import React from 'react';
import {Link} from 'react-router-dom'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem } from 'reactstrap';
import './navbar.css'

export default class Menu extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <div>
        <Navbar color="light" dark expand="md">
          <NavbarBrand href="/">
					<img src={process.env.REACT_APP_LOGO_CLARA} width="190" alt="Logo da DPE/MT" />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
							<Link to="/">
								<NavItem>
									<NavLink>Início</NavLink>
								</NavItem>
						  </Link>
							<Link to="/prisao">
								<NavItem>
									<NavLink>Prisão</NavLink>
								</NavItem>
						  </Link>
							<Link to="/penhora">
								<NavItem>
									<NavLink>Penhora</NavLink>
								</NavItem>
						  </Link>
              <Link to="/justificativa">
								<NavItem>
									<NavLink>Justificativa</NavLink>
								</NavItem>
						  </Link>
           </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/navbar.jsx